import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "rv-h" }
const _hoisted_3 = { class: "rv-tiles" }
const _hoisted_4 = { class: "rv-tn" }
const _hoisted_5 = { class: "rv-tt" }
const _hoisted_6 = {
  key: 0,
  class: "rv-td"
}
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "rv-h" }
const _hoisted_9 = {
  key: 0,
  class: "rv-tiles"
}
const _hoisted_10 = { class: "rv-tn" }
const _hoisted_11 = { class: "rv-tt" }
const _hoisted_12 = {
  key: 0,
  class: "rv-td"
}
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.accs.length)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          id: _ctx.prefix + '-acc',
          class: "rv-sec"
        }, [
          _createElementVNode("h3", _hoisted_2, "Accountabilities (" + _toDisplayString(_ctx.accs.length) + ")", 1),
          _createElementVNode("ol", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accs, (a, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: i,
                class: "rv-tile"
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(i + 1), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(a.value), 1),
                  (a.value2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(a.value2), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shown, (section, i) => {
      return (_openBlock(), _createElementBlock("section", {
        key: section.id || i,
        id: _ctx.prefix + '-' + (section.id || i),
        class: "rv-sec"
      }, [
        _createElementVNode("h3", _hoisted_8, _toDisplayString(section.label), 1),
        (section.tiles)
          ? (_openBlock(), _createElementBlock("ol", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.tiles, (t, k) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: k,
                  class: "rv-tile"
                }, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(k + 1), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(t.title), 1),
                    (t.desc)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(t.desc), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([ /purpose/i.test(section.label || '') ? 'rv-purpose' : 'rv-card', 'rv-rich ve-body' ]),
              innerHTML: section.html
            }, null, 10, _hoisted_13))
      ], 8, _hoisted_7))
    }), 128))
  ], 64))
}